'use client';

import { Textfield } from '@lichtblick/photon/molecules/textfield';
import { startTransition, useState } from 'react';

import { i18n } from '../../i18n';

type ProviderFieldProps = {
  defaultValue?: string;
  invalidZip?: boolean;
  name: string;
  label?: string;
  submitAction: (zip?: string) => void;
};

export const ZipCodeField: React.FC<ProviderFieldProps> = ({ defaultValue, invalidZip, name, label, submitAction }) => {
  const [isInvalidValue, setIsInvalidValue] = useState(false);
  const [isMissingValue, setIsMissingValue] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const missingMessage = isMissingValue ? i18n.validation.missing : undefined;
  const invalidMessage = isInvalidValue ? i18n.validation.invalid : undefined;

  return (
    <Textfield
      autoComplete="postal-code"
      data-testid={`text-${name}`}
      defaultValue={defaultValue}
      errorMessage={missingMessage ?? invalidMessage}
      forcedError={!isMissingValue && invalidZip && !isFocused ? i18n.validation.invalid : undefined}
      inputMode="numeric"
      label={label ?? 'Postleitzahl'}
      maxLength={5}
      minLength={5}
      name={name}
      onBlur={(e) => {
        setIsFocused(false);
        setIsInvalidValue(!e.target.validity.valid || !e.target.validity.valueMissing);
        setIsMissingValue(e.target.validity.valueMissing);
      }}
      onChange={(e) => {
        startTransition(() => {
          submitAction(e.currentTarget.value);
        });
      }}
      onFocus={() => setIsFocused(true)}
      onInvalid={(e) => {
        e.preventDefault();
        setIsInvalidValue(!e.currentTarget.validity.valid && !e.currentTarget.validity.valueMissing);
        setIsMissingValue(e.currentTarget.validity.valueMissing);
      }}
      pattern="[0-9]{5}"
      required
      type="text"
    />
  );
};
